// extracted by mini-css-extract-plugin
module.exports = {"desktopAndTablet":"videoInline-module--desktopAndTablet--1vkyG","mobileOnly":"videoInline-module--mobileOnly--17pXu"};